import { useEffect, useState } from "react";
import axios from "axios";
import qs from "qs";
import Loader from "../Helpers/Loader";
import Pagination from "../IndexPage/Pagination";
import List from "../IndexPage/List";
import Filters from "./Filters";

const MediaIndex = () => {
	// prevent useEffect from running on first render
	const [skipCount, setSkipCount] = useState(true);

	// news list
	const [media, setMedia] = useState([]);

	// loading states
	const [isLoading, setIsLoading] = useState(true);

	// search & filters states
	const [filtersList, setFiltersList] = useState([]);
	const [query, setQuery] = useState({});
	const [filters, setFilters] = useState({
		category: "",
		type: "",
	});
	const [searchTerm, setSearchTerm] = useState("");

	// pages state
	const [totalPages, setTotalPages] = useState(1);
	const [currentPage, setCurrentPage] = useState(1);

	useEffect(() => {
		// get list of filters
		axios.get("/wp-json/fords/v1/filters?type=fords_media").then((res) => {
			setFiltersList(res.data);
		});
	}, []);

	useEffect(() => {
		if (skipCount) setSkipCount(false);

		// prevent query object from running on first render
		if (!skipCount) {
			// build the query
			const queryObject = {
				...filters,
				page: currentPage,
			};
			if (searchTerm) {
				queryObject.q = searchTerm;
			}
			setQuery(queryObject);
			setIsLoading(true);
		}
	}, [filters, currentPage]);

	useEffect(() => {
		// query url
		const searchUrl = `/wp-json/fords/v1/media?${qs.stringify(query)}`;

		// get the news
		axios.get(searchUrl).then((res) => {
			setMedia(res.data.media);
			setIsLoading(false);
			setTotalPages(Math.ceil(res.data.postCount / 12));
		});
	}, [query]);

	// Debounce search term change
	useEffect(() => {
		const delayDebounceFn = setTimeout(() => {
			// build the query
			const queryObject = {
				...filters,
				page: currentPage,
			};
			if (searchTerm) {
				queryObject.q = searchTerm;
			}
			setQuery(queryObject);
			setIsLoading(true);
		}, 700);

		return () => clearTimeout(delayDebounceFn);
	}, [searchTerm]);

	const handleLoading = () => {
		if (isLoading) {
			return <Loader />;
		}
		return <List posts={media} card={"MediaCard"} />;
	};

	return (
		<div className="news-index">
			<Filters
				filters={filters}
				filtersList={filtersList}
				setFilters={setFilters}
				searchTerm={searchTerm}
				setSearchTerm={setSearchTerm}
				setCurrentPage={setCurrentPage}
			/>
			{handleLoading()}
			{totalPages > 1 && (
				<Pagination
					currentPage={currentPage}
					setCurrentPage={setCurrentPage}
					totalPages={totalPages}
				/>
			)}
		</div>
	);
};

export default MediaIndex;
